import { useState } from "react";
import { Link } from "react-router-dom";
import "../navbar.css";

function Navbar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <nav className="navbar">

      {/* Logo */}
      <div className="left_side">
        <Link to="/" onClick={closeSidebar}>
          <img
            className="logo_placeholder"
            src="./images/dlc_transparent.png"
            alt="Logo"
          />
        </Link>
      </div>

      {/* Mobile Sidebar */}
      <ul className={`sidebar ${sidebarOpen ? "sidebar-open" : ""}`}>

        <li className="close-button">
          <button onClick={closeSidebar} aria-label="Close navigation menu">
            <img
              src="./images/close.svg"
              alt=""
            />
          </button>
        </li>

        <li>
          <Link to="/" onClick={closeSidebar}>
            Home
          </Link>
        </li>

        <li>
          <Link to="/about" onClick={closeSidebar}>
            About
          </Link>
        </li>

        <li>
          <Link to="/service" onClick={closeSidebar}>
            Services
          </Link>
        </li>

        <li>
          <Link to="/portfolio" onClick={closeSidebar}>
            Portfolio
          </Link>
        </li>
      </ul>

      {/* Desktop Navigation */}
      <ul className="nav-links">
        <li>
          <Link className="hideOnMobile" to="/">
            Home
          </Link>
        </li>

        <li>
          <Link className="hideOnMobile" to="/about">
            About
          </Link>
        </li>

        <li>
          <Link className="hideOnMobile" to="/service">
            Services
          </Link>
        </li>

        <li>
          <Link className="hideOnMobile" to="/portfolio">
            Portfolio
          </Link>
        </li>

        {/* Mobile Menu Button */}
        <li className="menu__button">
          <button
            onClick={() => setSidebarOpen(true)}
            aria-label="Open navigation menu"
          >
            <img
              src="./images/menu.svg"
              alt=""
            />
          </button>
        </li>
      </ul>

      {/* Call Button */}
      <a href="tel:+1708-595-1156" className="btn-primary">
        Call Us Now
      </a>

    </nav>
  );
}

export default Navbar;


// import { Link } from "react-router-dom
// import "../navbar.css";

// const showSidebar = () => {
//     const sidebar = document.querySelector('.sidebar')
//     sidebar.style.display = "flex"
// }

// const hideSidebar = () => {
//     const sidebar = document.querySelector('.sidebar')
//     sidebar.style.display = "none"
// }

// function Navbar() {
//   return (
//     <nav className="navbar">

//       <div className="left_side">
//         <a href="/"><img className="logo_placeholder" src="./images/dlc_transparent.png" alt="Logo" /></a>
//       </div>

//       <ul className="sidebar" style={{ display: "none"}}>
//         <li onClick= {(e) => hideSidebar(e)}><img src="./images/close.svg" alt="close navbar menu" height="26" viewBox="0 96 960 960" width="26"></img></li>
//         <li><Link to="/">Home</Link></li>
//         <li><Link to="/about">About</Link></li>
//         <li><Link to="/service">Services</Link></li>
//         <li><Link to="/portfolio">Portfolio</Link></li>
//       </ul>
      

//       <ul className="nav-links">
//         <li><Link className="hideOnMobile" to="/">Home</Link></li>
//         <li><Link className="hideOnMobile" to="/about">About</Link></li>
//         <li><Link className="hideOnMobile" to="/service">Services</Link></li>
//         <li><Link className="hideOnMobile" to="/portfolio">Portfolio</Link></li>
//         <li className="menu__button" onClick= {(e) => showSidebar(e)}><img src="./images/menu.svg" alt="Menu" height="26" viewBox="0 96 960 960" width="26"></img></li>
//       </ul>

//       <a href="tel:+7085951156" className="btn-primary">Call Us Now</a>
//     </nav>
//   );
// }

// export default Navbar;